<template>
  <div>
    <v-card flat>
      <v-card-title class="pa-0" style="word-break: unset">
        <v-list-item>
          <v-list-item-content class="pb-0">
            <v-row>
              <v-col cols="12" class="my-auto">
                <div class="body-1 black--text">
                  Daftar Penilaian
                  <p class="body-2 grey--text text--darken-1" v-if="kKinerjaFungsiPsp === 2">
                    di bawah ini adalah daftar <strong>Fasilitator PSP</strong> yang menjadi binaan Anda, selaku
                    Koordinator Fasilitatornya (KFSP). Silahkan dinilai sesuai dengan kondisi fasilitator binaan Anda.
                  </p>
                  <p class="body-2 grey--text text--darken-1" v-else-if="kKinerjaFungsiPsp === 3">
                    di bawah ini adalah daftar <strong>Koordinator Fasilitator</strong> di naungan BGP/BBGP instansi
                    Anda. Anda selaku Penjab BGP/BBGP diwajibkan memberikan penilaian terhadap kinerja mereka selama
                    satu semester (termin)
                  </p>
                </div>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </v-card-title>
      <v-card-text>
        <base-list-table :hideHeader="true" :loading="loading" :item="data" :total="total" :usePaging="false">
          <template slot-scope="{ item }">
            <td class="px-0 mx-0">
              <v-list two-line>
                <v-list-item dense class="px-0">
                  <v-list-item-avatar class="mr-3 mt-5">
                    <v-avatar color="indigo lighten-1">
                      <v-icon dark>mdi-text-box-multiple</v-icon>
                    </v-avatar>
                  </v-list-item-avatar>
                  <v-list-item-content class="py-0">
                    <v-row>
                      <v-col cols="12" :lg="item.sekolah ? '5' : '3'">
                        <v-row>
                          <v-col cols="12" :lg="item.sekolah ? '6' : '12'">
                            <div class="grey--text caption">Evaluasi Kinerja</div>
                            <div style="font-size: 17px"> Termin {{ item.kinerja_ke }} </div>
                            <div class="grey--text text--darken-1 body-2">
                              Pendampingan Tahun {{ item.pendampingan_tahun }}
                            </div>
                          </v-col>
                          <v-col v-if="item.sekolah" cols="12" lg="6">
                            <div class="grey--text caption">Nama Sekolah</div>
                            <div class="body-2">{{ $getDeepObj(item, 'sekolah.nama') || '' }}</div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" lg="3">
                        <div style="font-size: 17px">
                          {{ $getDeepObj(item, 'nama_sasaran') || $getDeepObj(item, 'nama_sasaran') || '-' }}
                        </div>
                        <div class="mt-1">
                          <v-chip
                            small
                            outlined
                            :color="colorSasaran[$getDeepObj(item, 'psp_kinerja_sasaran.k_kinerja_sasaran_psp')]"
                          >
                            {{ $getDeepObj(item, 'psp_kinerja_sasaran.m_kinerja_fungsi_psp_sasaran.keterangan') || '' }}
                          </v-chip>
                        </div>
                      </v-col>
                      <v-col cols="12" :lg="item.sekolah ? '2' : '3'">
                        <div class="grey--text caption">Status Penilaian</div>
                        <div>
                          <v-chip :color="item.is_lengkap === 1 ? 'green' : 'grey'" class="white--text">
                            {{ item.is_lengkap === 1 ? 'Sudah' : 'Belum' }}
                          </v-chip>
                        </div>
                      </v-col>
                      <v-col cols="12" lg="2">
                        <div class="white--text body-2">Aksi</div>
                        <div>
                          <v-btn
                            :disabled="(!isEdit(item) && !item.is_lengkap) || item.is_tutup"
                            depressed
                            class="text-capitalize"
                            color="primary"
                            @click="onInstrumen(item)"
                          >
                            {{ isEdit(item) ? 'Nilai' : item.is_lengkap ? 'Lihat' : 'Nilai' }}
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
    </v-card>
    <modal-kinerja ref="modal" title="Form Evaluasi Kinerja" :progress="formulir.progress" generalError>
      <component
        ref="kinerja"
        :is="formulir.component"
        :is-edit="formulir.is_edit"
        :sasaran="formulir.sasaran"
        :instrumen="formulir.instrumen"
        :kelompok-instrumen="formulir.kelompokInstrumen"
        :jawaban="formulir.jawaban"
        :page="formulir.page"
        :detail="formulir.detail"
        @next="onNext"
        @prev="onPrev"
        @save="onSave"
        @close="onClose"
      />
    </modal-kinerja>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import list from '@mixins/list';
import ModalKinerja from '@components/popup/ModalKinerja';
import FormPembukaan from './forms/Pembukaan';
import FormInstrumen from './forms/Instrumen';

export default {
  name: 'ListPenilaian',
  components: { ModalKinerja, FormPembukaan, FormInstrumen },
  mixins: [list],
  props: {
    isAllowEdit: {
      type: Boolean,
      default: false,
    },
    kKinerjaFungsiPsp: {
      type: [String, Number],
    },
  },
  data() {
    return {
      sync: {},
      formulir: {},
      colorSasaran: {
        1: 'blue',
        2: 'orange',
        3: 'green',
        4: 'pink',
        5: 'indigo',
      },
    };
  },
  computed: {},
  methods: {
    ...mapActions('kinerja', ['fetch', 'getInstrumen', 'getDetail', 'update']),

    async fetchData() {
      return new Promise((resolve) => {
        const attr = this.attr;
        let params = Object.assign({}, this.params, this.$isObject(this.filters) ? this.filters : {});

        if (!this.sync[this.kKinerjaFungsiPsp || 'lain']) {
          params.resinkron = 1;
        }

        if (this.kKinerjaFungsiPsp) {
          params.k_kinerja_fungsi_psp = this.kKinerjaFungsiPsp;
        }

        this.fetch({ attr, params }).then(({ data, meta }) => {
          this.sync[this.kKinerjaFungsiPsp || 'lain'] = true;
          this.data = data || [];
          this.dataMeta = meta;
          this.total = data.total || data.length || 0;
          // this.pageTotal = data.last_page || 1;
          // this.params.limit = data.per_page || this.params.limit;

          this.$emit('meta', meta);
          resolve(true);
        });
      });
    },

    isEdit(item) {
      return this.isAllowEdit && +item.is_aktif === 1;
    },

    async onInstrumen(item) {
      const pspKinerjaSasaran = item.psp_kinerja_sasaran || {};
      const id = item.psp_kinerja_id;
      const instrumen = await this.getInstrumen({ id });

      let jawaban = {};
      for (const ins of item.psp_kinerja_instrumens || []) {
        jawaban[ins.k_kinerja_instrumen_psp] = ins.catatan || ins.k_kinerja_opsi_psp;
      }

      let kelompokInstrumen = {};
      for (const ins of instrumen[pspKinerjaSasaran.instrumen]) {
        if (kelompokInstrumen[ins.kelompok || 'lain']) {
          kelompokInstrumen[ins.kelompok || 'lain'].push(ins);
        } else {
          kelompokInstrumen[ins.kelompok || 'lain'] = [ins];
        }
      }

      this.$set(this.formulir, 'id', id);
      this.$set(this.formulir, 'sasaran', pspKinerjaSasaran.instrumen);
      this.$set(this.formulir, 'instrumen', instrumen[pspKinerjaSasaran.instrumen] || []);
      this.$set(this.formulir, 'kelompokInstrumen', kelompokInstrumen);
      this.$set(this.formulir, 'jawaban', jawaban);
      this.$set(this.formulir, 'progress', 0);
      this.$set(this.formulir, 'is_edit', this.isEdit(item));
      this.$set(this.formulir, 'component', 'FormPembukaan');
      this.$set(this.formulir, 'detail', item);

      this.$refs.modal.open();
    },

    async onNext(page = 1) {
      const kelompkInstrumen = Object.keys(this.formulir.kelompokInstrumen || {});

      this.$set(this.formulir, 'component', 'FormInstrumen');
      this.$set(this.formulir, 'page', page);
      this.$set(this.formulir, 'progress', 100 * (page / kelompkInstrumen.length));

      if (page > 1) {
        const params = this.$refs.kinerja.getValue();

        const jawabanOld = Object.assign({}, this.formulir.jawaban);
        let jawaban = {};
        for (const param of params) {
          jawaban[param.k_kinerja_instrumen_psp] = param.k_kinerja_opsi_psp;
        }

        this.$set(this.formulir, 'jawaban', Object.assign({}, jawabanOld, jawaban));
      }

      this.$nextTick(() => {
        this.$refs.kinerja.reset();
      });
    },

    onPrev(page = 1) {
      const instrumen = this.$getDeepObj(this.formulir.instrumen, 'instrumen') || {};

      this.$set(this.formulir, 'component', 'FormInstrumen');
      this.$set(this.formulir, 'page', page);
      this.$set(this.formulir, 'progress', 100 * (page / Object.keys(instrumen).length));

      this.$nextTick(() => {
        this.$refs.kinerja.reset();
      });
    },

    onSave() {
      if (!this.formulir.is_edit) {
        this.$refs.modal.close();
        return;
      }

      const params = this.$refs.kinerja.getValue();
      const jawabanOld = Object.assign({}, this.formulir.jawaban);

      let jawaban = {};
      for (const param of params) {
        jawaban[param.k_kinerja_instrumen_psp] = param.k_kinerja_opsi_psp || param.catatan;
      }

      this.$set(this.formulir, 'jawaban', Object.assign({}, jawabanOld, jawaban));

      const id = this.formulir.id;
      const jawabans = Object.keys(this.formulir.jawaban).map((kInstrumen) => {
        if ([16, 67, 119, 172, 212, 263, 316, 366].includes(+kInstrumen)) {
          return {
            k_kinerja_instrumen_psp: kInstrumen,
            catatan: this.formulir.jawaban[kInstrumen],
          };
        }

        return {
          k_kinerja_instrumen_psp: kInstrumen,
          k_kinerja_opsi_psp: this.formulir.jawaban[kInstrumen],
        };
      });

      this.update({ id, params: { instrumen: jawabans } }).then(() => {
        this.fetchData();
        this.$success('Berhasil disimpan');
        this.$refs.modal.close();
      });
    },

    onClose() {
      this.$refs.modal.close();
    },
  },
};
</script>

<style scoped></style>
